import auth from "../../middlewares/auth";
export const settingsWeeksRoute = [
  {
    path: '/settings/weeks',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/week/WeekList'),
    name: 'settings_week',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/week/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/week/WeekForm'),
    name: 'settings_week_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/week/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/week/WeekForm'),
    name: 'settings_week_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];